const trustItems = [
  {
    icon: 'ri-shield-check-line',
    title: 'Weryfikuj linki',
    desc: 'Zawsze sprawdzaj linki przed kliknięciem. Upewnij się, że prowadzą do zaufanych źródeł.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Unikaj fałszywych stron',
    desc: 'Korzystaj tylko ze sprawdzonych arkuszy i oficjalnych platform zakupowych.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Chroń dane osobowe',
    desc: 'Nigdy nie udostępniaj poufnych danych na nieznanych stronach internetowych.',
  },
  {
    icon: 'ri-star-line',
    title: 'Sprawdzaj opinie',
    desc: 'Przed zakupem zawsze czytaj recenzje i opinie innych użytkowników.',
  },
];

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-accent-50">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-xs font-semibold tracking-wider uppercase mb-4">
            Bezpieczeństwo
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Bezpieczeństwo przede wszystkim
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Podczas korzystania z arkuszy produktów warto pamiętać o kilku podstawowych zasadach bezpieczeństwa.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h4 className="font-semibold text-foreground-900 mb-2">{item.title}</h4>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}